import request from '@/utils/axios'
// 登录
export function Login (params) {
  return request({
    url: '/api/dingback',
    method: 'get',
    params
  })
}
